<template>
  <b-col md="3" sm="3" xl="3" class="text-center animated fadeIn fadeOut">
    <b-card :bg-variant="level()">
      <!-- :style="{ cursor: 'pointer'}" -->
      <p style="width: 30%;display:inline-block; height:100%;">
        <b-badge style="font-size: x-small;" :variant="has_wc_online ? (status && status.is_wc ? 'dark' : 'light') : 'gray'" v-if="status.is_wc || info.is_wc">WEBCastle</b-badge>
        <b-badge style="font-size: x-small;" :variant="has_wsf_online ? (status && status.is_wsf ? 'dark' : 'light') : 'gray'" v-if="status.is_wsf || info.is_wsf">WSFinder</b-badge>
        <b-badge style="font-size: x-small;" :variant="status && status.is_wmds ? 'dark' : 'light'" v-if="status.is_wmds || info.is_wmds">WMDS</b-badge>
        <b-badge style="font-size: x-small;" :variant="status && status.is_wf ? 'dark' : 'light'" v-if="status.is_wf || info.is_wf">WFDetector</b-badge>
      </p>
      <p style="width: 50%; display:inline-block; height:100%; text-align: center; margin-left:10px;">
        <span style="display: inline-block;"><b-badge variant="info">{{info.domain ? 'Domain' : 'Server'}}</b-badge></span>
        <br>
        <span v-if="info.name" style="display: inline-block;"><b-badge variant="info">{{ info.name }}</b-badge></span>
        <br v-if="info.name">
        <span style="display: inline-block; border-top: 1px solid white; margin-top: 12px; padding-top:10px;"> {{(info.domain ? info.domain : info.ip_addr) | truncate(18) }} </span>
      </p>
    </b-card>
  </b-col>
</template>

<script>
export default {
  props : ['hot', 'info', 'wc_pong_list', 'wsf_pong_list'],
  watch: {},
  data : () => {
    return {
      is_danger : false,
      status : {}
    }
  },
  computed: {
    has_wc_online() { return (this.wc_pong_list || []).indexOf(this.info.wc_agent_id) > -1 },
    has_wsf_online() { return (this.wsf_pong_list || []).indexOf(this.info.wsf_agent_id) > -1 }
  },
  methods: {
    level() { return this.status && (this.status.domain || this.status.ip_addr) ? 'danger' : 'success' },
    init(type='default') {
      // console.log(_.filter(this.hot, x => (x.domain && this.info.domain == x.domain) || (x.ip_addr && this.info.ip_addr == x.ip_addr)))
      this.status  = Object.assign(
        {},
        this.status,
        this.hot ? _.filter(this.hot, x => (x.domain && this.info.domain == x.domain) || (x.ip_addr && this.info.ip_addr == x.ip_addr))[0] : {}
      )
    },
  },
  created () { console.info('wmds-agent-item.vue created') },
  destroyed () { console.log('wmds-agent-item.vue destroyed') },
  mounted () {  console.log('wmds-agent-item.vue mounted'); this.init(); setTimeout(this.$forceUpdate(), 3000)  },
}
</script>
